import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="bg-emerald-950 py-24 px-4 relative overflow-hidden" data-id="element-59">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-emerald-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-60"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-62">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-63">
            Esta Oferta No Dura Para Siempre
          </h2>
          <p className="text-xl md:text-2xl text-emerald-100 mb-10" data-id="element-64">
            Todos los tomos + 6 bonos gratis + acceso inmediato. Todo por
            $19.990.
          </p>

          <div className="flex flex-col items-center" data-id="element-65">
            <CTAButton href="https://checkout.rosetadigital.com/cart/46376655913113:1" className="mb-6" data-id="element-66">
              ✅ QUIERO MI PACK AHORA
            </CTAButton>
            <p className="text-emerald-300/80 text-sm font-medium" data-id="element-67">
              🔒 Pago seguro · Acceso inmediato · Garantía 7 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}